export default __webpack_public_path__ + "media/images/app-icon-b2a63c152feaf8153fdb3e2698f5a912.svg";